module.exports = __webpack_public_path__ + "img/ranking-benefits.764ff63a.png";